<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex xs6>
        <h1>Document Types (Archived)</h1>
      </v-flex>
      <v-flex xs6 class="text-right">
        <v-btn color="accent" outlined :to="'/management/document-types'">Active Document Types</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-data-table :headers="headers"
                        :items="archivedDocumentTypes"
                        item-key="id"
                        class="elevation-1">
            <template v-slot:item.action="{ item }">
              <v-icon color="accent"
                      class="mr-2"
                      @click="restoreDialogForDocumentType(item)">
                restore
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <template>
        <v-row justify="center">
          <v-dialog v-model="restoreConfirmDialog" persistent max-width="290">
            <v-card>
              <v-card-title class="headline pt-1 pr-1">
                Confirm Restore
                <v-spacer></v-spacer>
                <v-btn icon @click="restoreConfirmDialog = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text> Are you sure you want restore this document type?</v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn outlined color="accent" @click="restoreMethod(documentType)">Restore</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'list-archived-document-types',
  created () {
    this.loadArchivedDocumentTypes()
  },
  data () {
    return {
      deleteConfirmDialog: false,
      restoreConfirmDialog: false,
      user: null
    }
  },
  methods: {
    ...mapActions({
      loadArchivedDocumentTypes: 'documentType/loadArchives',
      restoreDocumentType: 'documentType/restoreDocumentType'
    }),

    restoreDialogForDocumentType (item) {
      this.restoreConfirmDialog = true
      this.documentType = item
    },

    async restoreMethod (documentType) {
      this.restoreConfirmDialog = await this.restoreDocumentType(documentType.id)
    }

  },
  computed: {
    ...mapGetters({
      archivedDocumentTypes: 'documentType/archivedList',
      headers: 'documentType/headers'
    })
  }
}
</script>
